module.exports = __webpack_public_path__ + "static/feature-phone-mobile-1-f516784485d27778596366d9babe608d.png";